// extracted by mini-css-extract-plugin
module.exports = {"description":"_2ikHvOA0sD8oDlbATHtip4"};